import { useMutation } from '@apollo/client';

import type {
  AddUserToAccountMutation,
  AddUserToAccountMutationVariables,
} from 'src/graphql/generated';
import { ADD_USER_TO_ACCOUNT_MUTATION } from 'src/graphql/gql_mutations';

export const useAddUserToAccount = () => {
  const [mutate, { data, loading, error }] = useMutation<
    AddUserToAccountMutation,
    AddUserToAccountMutationVariables
  >(ADD_USER_TO_ACCOUNT_MUTATION);

  return { mutate, data, loading, error };
};
